import API from "../api";

const getHiddenCodes = async () => {
  const { ok, data, message } = await API.get("/hidden-code");
  if (!ok) throw new Error(message);
  return data;
};

export { getHiddenCodes };
